import React, { FC, useEffect } from 'react';
import DataInfo from '@components/data_info';
import FormField from '@components/form_field';
import { useForm } from '@hooks/helpers/useForm';
import Input from '@components/common/input';
import { useLocales } from '@hooks/helpers/useLocales';
import styles from './styles.module.scss';
import { EVerificationStatus, TConsumer } from '@xeppt/xeppt-sdk/types';
import { getVerificationStatus } from '@utils/index';
import { kyc_error_localizations } from '@const/index';

interface IProps {
    consumer?: TConsumer;
}

const mapPatenoErrors = (code: string) => {
    const errs: { [key: string]: string } = {
        PT00001: 'KycScreeningError01',
        PT00002: 'KycScreeningError02',
        PT00003: 'KycScreeningError03',
        PT00004: 'KycScreeningError04',
        PT00005: 'KycScreeningError05',
        PT00006: 'KycScreeningError06',
        PT00007: 'Unknown error'
    };

    return errs?.[code] || code;
};

const KYCSection: FC<IProps> = ({ consumer }) => {
    const form = useForm({});
    const { labelLocale } = useLocales();

    useEffect(() => {
        if (consumer) {
            form.reset({
                first_name: consumer?.profile?.first_name,
                last_name: consumer?.profile?.last_name,
                verification: consumer?.verification
            });
        }
    }, [consumer]);

    return (
        <div className={styles.wrapper}>
            <DataInfo label="KYC" form={form}>
                <FormField
                    name="first_name"
                    renderComponent={(props) => {
                        return <Input full {...props} label={labelLocale('first_name')} />;
                    }}
                />
                <FormField
                    name="last_name"
                    renderComponent={(props) => {
                        return <Input full {...props} label={labelLocale('last_name')} />;
                    }}
                />
                <FormField
                    name="verification.verification_ref"
                    renderComponent={(props) => {
                        return <Input full {...props} label="Ref" />;
                    }}
                />
                <FormField
                    name="verification.kyc_status"
                    renderComponent={({ value, ...props }) => {
                        return (
                            <Input
                                full
                                //@ts-ignore
                                value={getVerificationStatus(value as EVerificationStatus)}
                                {...props}
                                label="KYC Status"
                            />
                        );
                    }}
                />
                <FormField
                    name="verification.bank_status"
                    renderComponent={({ value, ...props }) => {
                        return (
                            <Input
                                full
                                //@ts-ignore
                                value={getVerificationStatus(value as EVerificationStatus)}
                                {...props}
                                label="Bank Status"
                            />
                        );
                    }}
                />
            </DataInfo>
            <div className={styles.codes}>
                <h2>Verification error codes</h2>
                <ul className={styles.codes_list}>
                    {form
                        .getValues()
                        ?.verification?.verification_code?.split(',')
                        .map((item: string) => {
                            return (
                                <li key={item}>
                                    {mapPatenoErrors(item)}{' '}
                                    {kyc_error_localizations?.[mapPatenoErrors(item)] ||
                                        mapPatenoErrors(item)}
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
};

export default KYCSection;
